import { Link } from "react-router-dom";
import { MessageCircle } from "lucide-react";
import { Seo } from "@/components/Seo";
import { buildStockWhatsAppUrl } from "@/lib/whatsapp";

export default function TentangPage() {
  const waUrl = buildStockWhatsAppUrl();
  return (
    <>
      <Seo
        title="Tentang"
        description="Nofina Movie adalah toko produk digital yang membantu pelanggan menemukan, memilih, dan memesan subscription digital dengan proses sederhana melalui WhatsApp."
      />
      <div className="mx-auto max-w-3xl px-4 py-12 sm:px-6 lg:px-8">
        <header className="max-w-2xl">
          <h1 className="text-3xl font-extrabold text-nm-text sm:text-4xl">
            Tentang Nofina Movie
          </h1>
        </header>

        <div className="mt-6 space-y-4 text-sm leading-relaxed text-nm-muted sm:text-base">
          <p>
            Nofina Movie adalah toko produk digital yang membantu pelanggan
            menemukan, memilih, dan memesan subscription digital dengan proses
            yang sederhana. Melalui katalog Nofina Movie, pelanggan dapat melihat
            pilihan platform, menentukan durasi, memeriksa harga, dan melanjutkan
            pesanan melalui WhatsApp tanpa perlu membuat akun.
          </p>
          <p>
            Kami mengutamakan informasi produk yang jelas, alur pemesanan yang
            praktis, dan bantuan setelah aktivasi sesuai ketentuan yang berlaku.
          </p>
        </div>

        <div className="mt-8 flex flex-col gap-3 sm:flex-row">
          <Link
            to="/produk"
            data-testid="tentang-catalog-cta"
            className="inline-flex h-11 items-center justify-center rounded-lg bg-nm-red px-6 font-semibold text-white transition-colors hover:bg-nm-red-hover"
          >
            Lihat Semua Produk
          </Link>
          <a
            href={waUrl}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="tentang-whatsapp"
            className="inline-flex h-11 items-center justify-center gap-2 rounded-lg border border-nm-border bg-nm-surface px-6 font-semibold text-nm-text hover:border-wa/50 hover:text-wa"
          >
            <MessageCircle className="h-4 w-4" />
            Cek Stok via WhatsApp
          </a>
        </div>
      </div>
    </>
  );
}
